import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getEmployeeComparison = async (token, params) => {
  const url = `employees/${params.employee_id}/comparisons/${params.comparison_id}`

  const data = await apiGet({ url, token, params })
  return data
}

export function useEmployeeComparison({ params, options = {} }) {
  const token = useContext(AuthContext)

  return useQuery(
    [`employees/${params.employee_id}/comparison/${params.comparison_id}`, params],
    () => getEmployeeComparison(token, params),
    {
      ...options
    }
  )
}
